import { render, staticRenderFns } from "./LearnModule.vue?vue&type=template&id=15443ff6&scoped=true&"
var script = {}
import style0 from "./LearnModule.vue?vue&type=style&index=0&id=15443ff6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15443ff6",
  null
  
)

export default component.exports